var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSAndPGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 12,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.014 9.454c0 .37-.061.686-.183.952a2.337 2.337 0 01-.47.687c-.303.302-.67.518-1.102.647a4.79 4.79 0 01-1.378.193c-.42 0-.835-.06-1.245-.182a2.81 2.81 0 01-1.101-.626 2.62 2.62 0 01-.587-.791 2.299 2.299 0 01-.233-1.035h1.462c0 .193.038.371.116.537.077.166.175.308.293.426.17.17.374.282.614.338a3.128 3.128 0 001.478-.01c.244-.063.44-.172.587-.328a1.52 1.52 0 00.221-.304c.06-.107.088-.256.088-.448 0-.288-.093-.504-.281-.648a1.492 1.492 0 00-.648-.282 7.173 7.173 0 00-.875-.11 8.58 8.58 0 01-.863-.1 2.958 2.958 0 01-.769-.233c-.24-.11-.45-.256-.631-.437a2.012 2.012 0 01-.432-.653 2.218 2.218 0 01-.16-.87c0-.31.062-.593.188-.851.125-.259.291-.491.498-.698.258-.258.59-.461.996-.609a3.795 3.795 0 011.306-.22c.42 0 .825.064 1.212.193.388.129.715.319.98.57.236.221.426.472.57.752.144.28.22.587.227.92H5.43a1.14 1.14 0 00-.105-.416 1.373 1.373 0 00-.238-.36 1.246 1.246 0 00-.532-.31 2.173 2.173 0 00-.664-.11c-.221 0-.448.03-.68.088-.233.06-.43.174-.593.344a1.113 1.113 0 00-.194.287.888.888 0 00-.071.377c0 .258.073.455.221.592.148.136.34.223.576.26.25.037.533.07.846.1.314.03.6.062.858.099.295.044.574.124.836.238.262.115.49.266.687.454.195.188.35.415.464.68.114.266.172.565.172.897z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.193 11.8l-.553-.62c-.318.281-.667.488-1.046.62-.38.133-.774.2-1.18.2a3 3 0 01-.996-.166 2.53 2.53 0 01-.83-.47 2.24 2.24 0 01-.775-1.744c0-.487.128-.904.383-1.251.254-.347.592-.65 1.012-.908a6.1 6.1 0 01-.343-.393 2.762 2.762 0 01-.265-.393 1.885 1.885 0 01-.172-.42 1.89 1.89 0 01-.061-.499c0-.31.057-.587.172-.83.114-.244.267-.452.459-.625a1.92 1.92 0 01.68-.393c.262-.089.541-.133.836-.133.288 0 .563.042.825.127.262.085.493.21.692.376.2.167.358.37.476.61.118.239.177.514.177.824 0 .258-.037.489-.111.692a1.94 1.94 0 01-.31.553c-.132.166-.29.32-.47.46-.181.14-.378.272-.592.398l1.361 1.483a1.38 1.38 0 00.138-.437 7.2 7.2 0 00.084-1.046v-.442h2.025V8.47h-.907a5.59 5.59 0 01-.122.918 2.496 2.496 0 01-.354.842l1.45 1.572h-1.683zm-3.177-3.475c-.132.081-.254.159-.365.232-.11.074-.209.16-.293.255a1.093 1.093 0 00-.2.327 1.16 1.16 0 00-.071.426c0 .2.038.376.116.532.078.154.18.283.31.387.129.103.278.18.448.232.17.052.347.077.531.077.236 0 .472-.033.709-.1a1.25 1.25 0 00.608-.387l-1.793-1.981zm1.373-2.557c0-.273-.083-.483-.25-.63a.906.906 0 00-.624-.222.97.97 0 00-.61.205c-.176.136-.265.341-.265.614a.88.88 0 00.072.354c.048.11.107.216.177.316.07.1.15.193.238.282l.255.254c.118-.066.237-.134.36-.205.12-.07.23-.149.326-.238s.173-.192.232-.31a.924.924 0 00.089-.42z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.764 6.454c0 .377-.059.72-.177 1.03-.118.31-.294.576-.526.797a2.375 2.375 0 01-.869.515 3.602 3.602 0 01-1.195.182h-1.66v2.812h-1.418V3.942h3.078c.45 0 .848.06 1.195.183.347.121.636.291.869.509.232.217.408.481.526.791.118.31.177.653.177 1.03zm-1.439.012c0-.377-.11-.683-.332-.92-.221-.235-.572-.353-1.051-.353h-1.605v2.534h1.605c.48 0 .83-.116 1.051-.348.221-.233.332-.537.332-.913z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.176 11.79l-.166-.864c-.059.11-.148.227-.265.349a1.858 1.858 0 01-.438.327 2.884 2.884 0 01-.58.238 2.45 2.45 0 01-.687.094c-.457 0-.884-.063-1.278-.189a2.446 2.446 0 01-1.057-.686 3.116 3.116 0 01-.504-.675 3.738 3.738 0 01-.31-.753 4.653 4.653 0 01-.16-.835 10.237 10.237 0 01-.005-1.838c.025-.292.075-.566.148-.825.074-.258.178-.505.31-.741.133-.236.306-.462.52-.676a2.964 2.964 0 011.08-.686 3.58 3.58 0 011.256-.232c.487 0 .93.081 1.329.243.398.163.73.38.996.653.192.2.354.426.487.681.132.255.21.556.232.902h-1.461a.94.94 0 00-.122-.398 3.137 3.137 0 00-.221-.321c-.273-.318-.69-.476-1.251-.476-.229 0-.462.046-.697.138a1.534 1.534 0 00-.587.393c-.133.14-.24.303-.321.487a3.05 3.05 0 00-.188.581 3.811 3.811 0 00-.083.614 8.242 8.242 0 00.005 1.157c.015.21.044.419.089.625.044.207.107.404.188.593.081.188.188.352.32.492.156.17.35.295.582.377.232.081.463.122.692.122.258 0 .485-.041.68-.122.196-.081.36-.192.493-.332.214-.222.352-.456.415-.703.063-.247.094-.522.094-.824h-1.87V7.495h3.253v4.295h-.918z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.559 11.779c-.141.029-.243.05-.305.06a1.927 1.927 0 01-.304.017c-.473 0-.853-.122-1.14-.366-.288-.243-.432-.638-.432-1.184v-6.52h1.395v6.288c0 .17.033.304.1.404.066.1.217.15.453.15.06 0 .103-.002.133-.006a.815.815 0 01.1-.006v1.163z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__f",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.432 8.912c0 .487-.06.895-.177 1.223a3.21 3.21 0 01-.498.902c-.2.243-.474.453-.825.63a2.61 2.61 0 01-1.19.266c-.442 0-.84-.089-1.19-.265-.35-.178-.625-.388-.824-.631a3.215 3.215 0 01-.498-.902c-.118-.328-.177-.736-.177-1.223 0-.487.059-.895.177-1.223.118-.328.284-.63.498-.903.199-.243.474-.453.825-.63a2.6 2.6 0 011.19-.266c.442 0 .838.089 1.19.266.35.177.625.387.824.63.214.274.38.575.498.903.117.328.177.736.177 1.223zm-1.406 0c0-.273-.026-.537-.078-.792a1.351 1.351 0 00-.331-.659 1.187 1.187 0 00-.875-.365 1.174 1.174 0 00-.875.365c-.17.185-.28.404-.331.66a3.974 3.974 0 00-.078.79c0 .274.026.538.078.792.051.255.162.475.331.659a1.172 1.172 0 00.874.366 1.174 1.174 0 00.876-.366c.17-.184.28-.404.331-.659.052-.254.078-.518.078-.791z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.817 8.923c0 .546-.086 1.031-.256 1.455-.17.425-.427.777-.774 1.058a2.146 2.146 0 01-.614.354 2.178 2.178 0 01-.78.132c-.318 0-.625-.06-.92-.182a1.476 1.476 0 01-.697-.581l-.088.63h-1.195V3.799h1.383v2.656c.133-.162.33-.296.592-.404.262-.106.566-.16.914-.16.294 0 .559.04.791.122.233.08.437.195.614.343.686.568 1.03 1.424 1.03 2.568zM45.41 8.9c0-.25-.024-.498-.072-.742a1.538 1.538 0 00-.293-.652 1.424 1.424 0 00-.382-.322 1.07 1.07 0 00-.548-.132c-.273 0-.495.057-.664.17a1.2 1.2 0 00-.398.444c-.096.18-.16.38-.194.597a3.854 3.854 0 00.05 1.494c.066.292.2.53.399.715.095.089.21.16.343.21.133.052.288.077.464.077.215 0 .397-.044.548-.133.151-.088.279-.195.382-.32.148-.193.245-.412.294-.66.047-.246.071-.495.071-.746z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__h",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.96 11.723c-.119.052-.22.091-.305.116-.085.026-.212.04-.381.04-.303 0-.535-.082-.698-.244a.912.912 0 01-.276-.564c-.133.236-.355.44-.665.609-.31.17-.67.254-1.084.254-.347 0-.65-.05-.908-.149a1.92 1.92 0 01-.648-.399 1.651 1.651 0 01-.392-.575 1.787 1.787 0 01-.133-.68c0-.274.05-.517.15-.731.099-.214.238-.399.414-.554a1.91 1.91 0 01.62-.36c.236-.085.49-.139.764-.16l1.693-.122v-.355c0-.273-.064-.493-.193-.659-.13-.166-.39-.249-.781-.249-.325 0-.577.07-.758.21-.18.141-.278.344-.293.61h-1.34c.023-.325.098-.606.227-.842s.301-.43.514-.58A2.28 2.28 0 0149.23 6c.28-.074.583-.111.908-.111.495 0 .935.087 1.323.26.387.174.666.478.835.913.074.185.12.377.139.576.018.199.028.395.028.586v2.137c0 .133.023.227.071.282.048.055.131.083.25.083.058 0 .099-.003.121-.011a.13.13 0 00.055-.01v1.017zm-1.849-2.49l-1.461.11a1.08 1.08 0 00-.576.21c-.17.126-.255.307-.255.543a.63.63 0 00.25.526c.166.13.356.193.57.193.435 0 .79-.112 1.062-.337.273-.225.41-.552.41-.98v-.265z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__i",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 11.779c-.14.029-.242.05-.304.06a1.934 1.934 0 01-.305.017c-.472 0-.852-.122-1.14-.366-.288-.243-.432-.638-.432-1.184v-6.52h1.395v6.288c0 .17.033.304.1.404.066.1.217.15.453.15.06 0 .103-.002.133-.006a.816.816 0 01.1-.006v1.163z",
    fill: "#B4B4B4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s-and-p-global_svg__j",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 12
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v12H56V0z",
    fill: "#fff"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s-and-p-global_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 0H.715v1.274H56V0z",
    fill: "#B4B4B4"
  }))));
}
export default SvgSAndPGlobal;